// https://app.growthbook.io/features/prcng-472_v4
export const PERSONA_IN_TIERS_FLAG_NAME = 'prcng-472_v4'
